import { render, staticRenderFns } from "./RegistrarBolseiro.vue?vue&type=template&id=1742a250&scoped=true&"
import script from "./RegistrarBolseiro.vue?vue&type=script&lang=js&"
export * from "./RegistrarBolseiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742a250",
  null
  
)

export default component.exports